import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import Link from 'next/link'
import { createResource, useResource } from '@/lib/i18n'
import LazyLoad from 'react-lazyload'

type IList = {
  title: string
  image: string
  date: string
  text: string
  url: string
}

const resource = createResource({
  en: {
    title: 'News and Event',
  },
  id: {
    title: 'Berita dan Acara',
  },
})

const Promotion = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const isMobile = width <= 1000
  const newsList = [
    {
      image: '/images/about/news/news20261.jpg',
      title: 'Belajar Keuangan Tanpa Batas: Rangkul Komunitas Disabilitas, Kredit Pintar Hadirkan Kelas “Finansial Inklusif untuk Semua”',
      date: '30 Jan 2026',
      text: 'by Kredit Pintar',
      url: 'https://www.kreditpintar.com/education/finansial-inklusif-untuk-semua/',
    },
    {
      image: '/images/about/news/news20262.jpg',
      title: 'Perkuat Literasi Keuangan UMKM, Kredit Pintar dan CBI SME Burreau Berkolaborasi dengan Sahabat UMKM, Gelar One Day Training ‘Kiat Sukses Mendapatkan Modal Usaha’',
      date: '29 Jan 2026',
      text: 'by Kredit Pintar',
      url: 'https://www.kreditpintar.com/education/kelas-pintar-depok-2025/',
    },
    {
      image: '/images/about/news/news20263.jpg',
      title: 'Wujud Nyata Kepedulian terhadap Pendidikan Anak Usia Dini Kredit Pintar Revitalisasi PAUD Asy-Syukru di Bandar Lampung',
      date: '29 Jan 2026',
      text: 'by Kredit Pintar',
      url: 'https://www.kreditpintar.com/education/cs-kredit-pintar-lampung-2025/',
    },
    {
      image: '/images/about/news/news20264.jpg',
      title: 'Kredit Pintar dan Polimedia Dorong Literasi Keuangan melalui Program KOMA Untuk Cegah Kemiskinan Akibat Perilaku Impulsif dan Konsumtif',
      date: '29 Jan 2026',
      text: 'by Kredit Pintar',
      url: 'https://www.kreditpintar.com/education/kelas-pintar-bersama-jakarta-2025/',
    },
    {
      image: '/images/about/news/news20265.jpg',
      title: 'Perluas Literasi dan Inklusi Keuangan Kredit Pintar Menandatangani Kerjasama dengan Komunitas SUMKM di Finexpo 2025',
      date: '29 Jan 2026',
      text: 'by Kredit Pintar',
      url: 'https://www.kreditpintar.com/education/kredit-pintar-finexpo-2025/',
    },
  ]

  const PromotionDom = (item: IList) => {
    return (
      item && (
        <Link href={item.url} key={item.url}>
          <a target="_blank" className="banner">
            <LazyLoad>
              <img className="banner-product" src={item?.image} alt="banner-product" />
            </LazyLoad>
            <div className="text">{item.title}</div>
            <div className="date">
              {item.date},<span>{item.text}</span>
            </div>
          </a>
        </Link>
      )
    )
  }

  return (
    <Wrapper>
      <h2 className="title">{t('title')}</h2>
      <div className="container">
        <Swiper
          className="myswiper"
          spaceBetween={10}
          slidesPerView={1}
          breakpoints={{
            '@0.00': {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            '@0.75': {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            '@1.50': {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          pagination={{ clickable: true }}
        >
          {newsList.map((item, index) => (
            <SwiperSlide key={index} className="items">
              {PromotionDom(item)}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Wrapper>
  )
}
export default Promotion

const Wrapper = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 64px 20px 0 20px;
    text-align: center;
    max-width: 1440px;
    .title {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 32px;
    }
    .container {
      .items {
        margin-bottom: 40px;
        .banner {
          width: 100%;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 2px 150px 0px;
    text-align: center;
    max-width: 1440px;
    margin: 0 auto;
    .title {
      font-size: 36px;
      line-height: 48px;
      margin-bottom: 48px;
    }
  }
  .title {
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
  }
  .container {
    margin: 0 auto;
    .items {
      display: flex;
      overflow: hidden;
      justify-content: space-between;
      margin-bottom: 48px;
      .banner {
        border: 1px solid #e6eaf0;
        box-sizing: border-box;
        border-radius: 8px;
        overflow: hidden;
        max-width: 360px;
        .banner-product {
          width: 100%;
          max-width: 360px;
          height: 230px;
          object-fit: cover;
          border: 0;
        }
        .text {
          font-size: 20px;
          line-height: 28px;
          width: 100%;
          padding: 16px 16px 0 16px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-align: left;
        }
        .date {
          font-size: 16px;
          line-height: 22px;
          color: #9e9e9e;
          padding: 4px 16px 16px 16px;
          text-align: left;
          span {
            margin-left: 8px;
          }
        }
      }
    }
  }
`
